import { render, staticRenderFns } from "./AdminRebateIndex.vue?vue&type=template&id=582a8519&scoped=true"
import script from "./AdminRebateIndex.vue?vue&type=script&lang=js"
export * from "./AdminRebateIndex.vue?vue&type=script&lang=js"
import style0 from "./AdminRebateIndex.vue?vue&type=style&index=0&id=582a8519&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582a8519",
  null
  
)

export default component.exports